import { css } from 'emotion';

const pickerLayoutStyles = css`
	.payee-picker-paging-view {
		> div,
		> div > div {
			max-width: 100%;
		}
	}
	@media (min-width: 768px) {
		.payee-picker-paging-view {
			margin-right: -1rem;
		}
		.payee-picker-paging-view {
			> div > div:first-child {
				margin-right: 0;
			}
		}
	}
	.account-picker__header {
		display: inline-block;
		width: 100%;
	}

	.account-picker__header__accountsViewToggle {
		margin-bottom: 24px;
		margin-top: 18px;
	}

	.account-picker__header__listViewToggle {
		display: none;
	}

	.account-picker__header__listViewToggle__toggle {
		> div div:last-child {
			margin-left: 8px;
		}
	}

	.account-picker__header__searchContainer {
		display: inline-block;
		width: 100%;
		margin-bottom: 24px;
	}

	.account-picker__header__searchContainer .c-a-button {
		margin: 0 16px 16px 0;
	}

	.account-picker__items {
		display: inline-block;
		min-height: 140px;
		width: 100%;
	}

	.account-picker__items__item--col {
		width: 100%;

		> div {
			margin-right: 0;
		}

		button div span {
			word-break: break-all;
		}
	}

	@media screen and (min-width: 600px) {
		.account-picker__header__searchContainer__search {
			display: flex;
			> div {
				flex-grow: 0;
				margin-right: 16px;
			}
		}

		.account-picker__items__item--col:nth-child(odd) {
			> div {
				margin-right: 1rem;
			}
		}
	}

	@media (min-width: 1280px) {
		.account-picker__items__item--col:nth-child(odd) {
			> div {
				margin-right: 0;
			}
		}
	}

	.account-picker__items__item--fullWidth {
		margin-bottom: 8px;
		width: 100%;
	}

	.account-picker__pagingControl {
		margin-bottom: 24px;
	}

	.account-picker__pagingControl > div {
		margin-right: 0px;
	}

	.account-picker__favouritesMessage {
		margin-bottom: 24px;
	}

	@media (min-width: 600px) {
		.account-picker__header {
			display: inline-block;
			width: 100%;
			margin-bottom: 24px;
		}

		.account-picker__header__accountsViewToggle {
			margin-bottom: 24px;
		}

		.account-picker__header__listViewToggle {
			display: flex;
			flex-flow: row no-wrap;
			margin-right: -16px;
		}

		.account-picker__header__listViewToggle__label {
			margin-right: 5px;
			align-self: center;
			font-family: 'Source-Sans-Pro Text', sans-serif;
			font-size: 18px;

			@media print {
				display: none;
			}
		}

		.account-picker__header__searchContainer {
			display: block;
			margin-bottom: 0px;
		}

		.account-picker__header__searchContainer__search {
			margin-right: 16px;
			flex: 1;
		}

		.account-picker__items {
			display: flex;
			flex-flow: row wrap;
			justify-content: space-between;
		}

		.account-picker__items > .account-picker__items__item--col:nth-child(odd) {
		}

		.account-picker__items > .account-picker__items__item--col:last-child {
			margin-right: 0px;
		}

		@media screen {
			.account-picker__items__item--col {
				flex-basis: 50%;
				flex-grow: 0;
			}
		}
	}

	@media (min-width: 960px) {
		.account-picker__header__searchContainer {
			align-items: flex-start;
			display: flex;
			flex-direction: row;
			width: auto;
			justify-content: normal;
			margin-bottom: 0px;
		}

		.account-picker__header__accountsViewToggle {
			margin-bottom: 16px;
		}

		.account-picker__header__listViewToggle {
			margin-left: 16px;
		}
	}

	@media (min-width: 1280px) {
		.account-picker__header__searchContainer__search input {
			margin-right: 0;
			width: 320px;
		}

		.account-picker__header__searchContainer .c-a-button {
			margin-bottom: 0;
		}

		.account-picker__header__searchContainer .c-a-button__title {
			font-size: 16px !important;
		}

		.account-picker__items__item--col {
			flex-basis: 30%;
		}

		.account-picker__items > .account-picker__items__item--col {
			margin-right: 0px;
		}

		.account-picker__items > .account-picker__items__item--col:nth-child(3n) {
			margin-right: 0px;
		}
	}
`;

export { pickerLayoutStyles };
